import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full py-16 md:py-24" style={{
    backgroundColor: '#F0F7F4'
  }} data-id="element-173">
      <div className="max-w-4xl mx-auto px-4" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-175">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-12" style={{
          color: '#1A1A1A'
        }} data-id="element-176">
            ¿Por qué tu cuerpo se inflama después de los 30?
          </h2>

          <div className="space-y-6" data-id="element-177">
            <p className="text-lg md:text-xl leading-relaxed" style={{
            color: '#4A4A4A'
          }} data-id="element-178">
              Después de los 30, tu metabolismo cambia. El estrés del trabajo,
              la familia y la falta de descanso elevan tu{' '}
              <strong style={{
              color: '#1A1A1A'
            }} data-id="element-179">
                cortisol
              </strong>
              , la hormona que bloquea tu digestión y "secuestra" líquido en tu
              zona abdominal.
            </p>

            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-[#C5DDD1]" data-id="element-180">
              <p className="text-lg md:text-xl leading-relaxed mb-4" style={{
              color: '#1A1A1A',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-181">
                Vives en un ciclo vicioso:
              </p>

              <ul className="space-y-4" data-id="element-182">
                <li className="flex items-start gap-3" data-id="element-183">
                  <AlertCircleIcon className="w-6 h-6 flex-shrink-0 mt-1" style={{
                  color: '#C9A96E'
                }} data-id="element-184" />
                  <span className="text-base md:text-lg" style={{
                  color: '#4A4A4A'
                }} data-id="element-185">
                    Intentas comer sano, pero te sientes{' '}
                    <strong data-id="element-186">más hinchada</strong>.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-187">
                  <AlertCircleIcon className="w-6 h-6 flex-shrink-0 mt-1" style={{
                  color: '#C9A96E'
                }} data-id="element-188" />
                  <span className="text-base md:text-lg" style={{
                  color: '#4A4A4A'
                }} data-id="element-189">
                    Tomas tés milagrosos que te envían al baño pero{' '}
                    <strong data-id="element-190">no bajan el volumen</strong> de tu vientre.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-191">
                  <AlertCircleIcon className="w-6 h-6 flex-shrink-0 mt-1" style={{
                  color: '#C9A96E'
                }} data-id="element-192" />
                  <span className="text-base md:text-lg" style={{
                  color: '#4A4A4A'
                }} data-id="element-193">
                    Te esfuerzas en el gimnasio, pero la{' '}
                    <strong data-id="element-194">"barriga de estrés"</strong> sigue ahí, firme e
                    incómoda.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}